import {cache, inlineError} from '@s-ui/decorators'

import BreadcrumbsRepository from './BreadcrumbRepository.js'

/**
 * @class
 * @implements BreadcrumbsRepository
 */
export default class HttpBreadcrumbRepository extends BreadcrumbsRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Config} deps.config
   * @param {Fetcher} deps.fetchOrFail
   * @param {Function} deps.fromRawBreadcrumbResponseToDetailBreadcrumbVOMapper
   * @param {Function} deps.getBreadcrumbsErrorFactory
   * @param {Function} deps.log
   */

  constructor({
    config,
    fetchOrFail,
    fromRawBreadcrumbResponseToDetailBreadcrumbVOMapper,
    fromRawBreadcrumbResponseToNewsDetailBreadcrumbVOMapper,
    getBreadcrumbsErrorFactory,
    log
  }) {
    super()

    this._config = config
    this._fetchOrFail = fetchOrFail
    this._fromRawBreadcrumbResponseToDetailBreadcrumbVOMapper = fromRawBreadcrumbResponseToDetailBreadcrumbVOMapper
    this._fromRawBreadcrumbResponseToNewsDetailBreadcrumbVOMapper =
      fromRawBreadcrumbResponseToNewsDetailBreadcrumbVOMapper
    this._getBreadcrumbsErrorFactory = getBreadcrumbsErrorFactory
    this._log = log
  }

  @cache({ttl: '10 minutes', server: true})
  @inlineError
  async getBreadcrumbs(breadcrumbRequestObjectValueObject) {
    const breadcrumbRequestObject = breadcrumbRequestObjectValueObject.toJSON()
    const {GENERIC} = this._config.get('COMMON').ERRORS
    const [error, response] = await this._fetchOrFail
      .withErrorsFactories({
        [GENERIC]: ({message}) => {
          return this._getBreadcrumbsErrorFactory(message)
        }
      })
      .post(`${this._config.get('API_URL')}/url-builder/breadcrumbs`, {
        ...breadcrumbRequestObject
      })

    if (error) {
      return Promise.reject(error)
    }
    const {data} = response
    return this._fromRawBreadcrumbResponseToDetailBreadcrumbVOMapper.map(data)
  }

  @inlineError
  async getNewsBreadcrumbs({breadcrumbUrlBuilderRequestValueObject, detailParams}) {
    const {GENERIC} = this._config.get('COMMON').ERRORS
    const requestValueObjectRawValues = breadcrumbUrlBuilderRequestValueObject.toJSON()
    const payload = {...requestValueObjectRawValues}

    const [error, response] = await this._fetchOrFail
      .withErrorsFactories({
        [GENERIC]: ({message}) => {
          return this._getBreadcrumbsErrorFactory(message)
        }
      })
      .post(`${this._config.get('API_URL')}/url-builder`, payload)
    if (error) {
      return Promise.reject(error)
    }
    const {data} = response
    const mapperResponse = this._fromRawBreadcrumbResponseToNewsDetailBreadcrumbVOMapper.map({
      detailParams,
      urlsResponse: data
    })

    return mapperResponse
  }
}
